import axios from "axios";
import { ApiPath } from "../../../common/api-path/ApiPath";

export const getNacAutomationLogs = async (requestParams) => {
    const requestConfig = {
        params: requestParams,
        timeout: 12000,
        timeoutErrorMessage: "Request timed out while fetching NAC automation logs.",
    }
    const response = await axios.get(`${ApiPath.baseUrl}/nac-automation/events`, requestConfig);
    if (response.status >= 400) {
        throw new Error(response.errors);
    }
    return response.data;
}

export const getNacAutomationDetailsByRitm = async (requestId) => {
    const requestConfig = {
        params: {requestId},
        timeout: 12000,
        timeoutErrorMessage: "Request timed out while fetching NAC automation details.",
    }
    const response = await axios.get(`${ApiPath.baseUrl}/nac-automation/eventRecords`, requestConfig);
    if (response.status >= 400) {
        throw new Error(response.errors);
    }
    return response.data;
}

export const getNacAutomationEventsByRitm = async (requestId, switchName, portNumber) => {
    const requestConfig = {
        params: {requestId, switchName, portNumber},
        timeout: 12000,
        timeoutErrorMessage: "Request timed out while fetching NAC automation events.",
    }
    const response = await axios.get(`${ApiPath.baseUrl}/nac-automation/eventMessages`, requestConfig);
    if (response.status >= 400) {
        throw new Error(response.errors);
    }
    return response.data;
}